import axios from 'axios'
import { FormEvent, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import appConfig from '../../config'
import routes from '../../routes'
import { CurrentUser, updatedUser } from '../../slices/authSlice'
import { ProfileContainer } from './styled'

type FormDataType = {
  firstName: string
  lastName: string
  companyName: string
}

const ProfileForm = () => {
  const { currentUser }: { currentUser: CurrentUser } = useSelector(
    (state: any) => state.auth
  )

  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState<FormDataType>({
    firstName: currentUser?.firstName || '',
    lastName: currentUser?.lastName || '',
    companyName: currentUser?.companyName || '',
  })

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)
    axios
      .put(`${appConfig.API_URL}/users/update`, {
        ...formData,
      })
      .then(({ status, data }) => {
        if (status === 200) {
          navigate(routes.profile)
          dispatch(updatedUser(data.user))
          toast('Profile updated successfully')
        }
      })
      .catch((error) => {
        console.error(error)
        toast(error.response.data.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <ProfileContainer>
      {currentUser && (
        <div className="row border border-solid border-dark content-container p-4">
          <form onSubmit={handleSubmit}>
            <div className="py-2 d-flex flex-column">
              <label className="pb-2" htmlFor="name">
                First Name
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.firstName}
                name="firstName"
              />
            </div>
            <div className="py-2 d-flex flex-column">
              <label className="pb-2" htmlFor="name">
                Last Name
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.lastName}
                name="lastName"
              />
            </div>

            <div className="py-2 d-flex flex-column">
              <label className="pb-2" htmlFor="linkedin">
                Company Name
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.companyName}
                name="companyName"
              />
            </div>

            <button
              className={`profile-submit ${loading && 'disabled'}`}
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </form>
        </div>
      )}
    </ProfileContainer>
  )
}

export default ProfileForm
